<app-mergeable-trips-table
  [mergeTripElements]="mergeTripElements"
  [tripsToMerge]="allTrips()"
  [mergeTripForm]="mergeTripForm"></app-mergeable-trips-table>
<app-merging-details
  [allTrips]="allTrips()"
  [selectedTripIds]="selectedTripIds()"
  [distance]="distance()"
  [isTripMerged]="isTripMerged()"></app-merging-details>
@if (isMapVisible$ | async) {
  <app-map
    [id]="mapId"
    class="merge-trip-map"
    [markers]="selectedTripsPoints()"
    [clearMapData$]="entityId$"
    [invalidateSize$]="verticalSplitter.resizeEnd"></app-map>
}
<hr class="form-divider" />
<dv-dynamic-form
  class="dynamic-form-background"
  formTitle="{{ 'MergeTripTab.TripDetails' | translate | uppercase }}"
  [elements]="tripDetailsElements | translateElements"
  [formGroup]="tripDetailsForm">
</dv-dynamic-form>
<dv-save-panel
  labelSave="{{
    (isTripMerged() ? 'MergeTripTab.Split' : 'MergeTripTab.Merge') | translate
  }}"
  [disableSave]="
    (selectedTripIds().length < 2 ||
      !mergeTripForm?.valid ||
      !allTrips().length) &&
    !isTripMerged()
  "
  labelCancel=""
  (save)="onSave()">
</dv-save-panel>
